import { Store } from 'vuex';
import { inject, injectable } from 'inversify-props';
import { UniquePromise, ICommand, eventBus } from '@/utils';
import { types } from '@/store';
import { ICounterApi } from '@/apis';
import { AxiosResponse } from 'axios';

/** Merges any ServingLines chosen */
@injectable()
export class MergeServingLinesCommand implements ICommand<any> {
  @inject() private store!: Store<any>;
  @inject() private counterApi!: ICounterApi;

  private promise = new UniquePromise(false);
  private isMerging: boolean = false;

  async run() {
    return this.promise.run(async () => {
      if (!this.isMerging && this.store.state.auth.isAuthenticated && navigator.onLine && this.needSync) {
        this.isMerging = true;
        const requests = this.store.state.meals.mergeServingLines;
        if (requests.length > 0) {
          const response = await this.counterApi.mergeServingLines(requests);
          await this.clearServingLines(response);
        }
        this.isMerging = false;
      }
    });
  }

  private get needSync() {
    const result = this.store.state.meals.mergeServingLines.length > 0;
    return result;
  }

  private async clearServingLines(response: AxiosResponse<any>) {
    if (response.status === 200 && response.data.state === "Successful") {
      await this.store.dispatch(types.actions.clearServingLines);
      eventBus.$emit('syncNotice');
    }
  }
}
